export enum BrandStatusLabel {
    CREATED = 'created',
    REGENERATING = 'regenerating',
    REGENERATED = 'regenerated',
    FAILED_TO_REGENERATE = 'failed_to_regenerate',
    SENDING = 'sending',
    SENT = 'sent',
    FAILED_TO_SEND = 'failed_to_send',
    SKIPPED = 'skipped',
    EXPIRED = 'expired'
}

export interface IBrand {
    id: number;
    name: string;
    logo_url: string;
    email_status: BrandStatusLabel;
    sent_at: string | null;
    cycle: string;
}

export interface IBrandsResponse {
    count: number;
    next: null | undefined;
    previous: null | undefined;
    results: Array<IBrand>
}

export interface IBrandOwner {
    id: number;
    full_name: string;
    email: string;
}

export interface IBrandEmailOwnerResponse {
    bcc_emails: Array<string>;
    cc_emails: Array<string>;
    to_emails: Array<string>;
    subject: string;
    body: string;
    brand_name: string;
    client_email_id: number;
    edit_required: boolean;
    is_admin: boolean;
    owners: Array<IBrandOwner>
}
